import React, { useState } from 'react';
import MobileDevPageVideoStage from '@wix/da-ads/pkg/adunits/anon/MobileDevPageVideoStage';
import MobileDevPageStage320x100 from '@wix/da-ads/pkg/adunits/anon/MobileDevPageStage320x100';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { useSubscriptionTier } from '../../utils/hooks/useSubscriptionTier';
import { useShowMobileAd } from '../../ArtStage/hooks/useShowMobileAd';
import LoadingIndicator from '../../LoadingIndicator';
import ArtStage from '../../ArtStage';
import MonetizationStrip from '../../MonetizationStrip';
import ActionBar from '../../ActionBar';
import Sidebar from '../../Sidebar';
import Details from '../../DeviationViews/Details';
import SubPaywall from '../../DeviationViews/Full/_partials/SubPaywall';
import PanelPopup from '../../DeviationPage/_partials/PanelPopup';
import { DeviationTypes } from '../../types/deviation';
import { getCommentableTypeForDeviationType, isExtendedDeviationFullyLoaded } from '../redux/helpers';
import Comments from '../_partials/Comments';
import TierUpsell from '../_partials/TierUpsell';
import UserGiftSaleBanner from '../_partials/UserGiftSaleBanner';
import LiteratureTextualContent from '../../DeviationViews/TextualContent/Literature';
import MobileAdhesion from '@wix/da-ads/pkg/adunits/anon/MobileAdhesion';
import UserMobileAdhesion from '@wix/da-ads/pkg/adunits/user/MobileAdhesion';
import AnonOrUserUnit from '@wix/da-ads/pkg/adunits/AnonOrUserUnit';
import ErrorBoundary from '../../ErrorBoundary';
import { useSelector } from 'react-redux';
import { getCurrentAdSafety } from '../../Ads/redux/selectors';
import s from './MobileDeviationPage.scss';
const MobileDeviationPage = ({ deviation  })=>{
    const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    const deviationType = getDeviationType(deviation);
    const isJournal = deviationType === DeviationTypes.JOURNAL;
    const isLiterature = deviationType === DeviationTypes.LITERATURE;
    const isJournalOrLit = isJournal || isLiterature;
    const { typeId , deviationId  } = deviation;
    const commentableTypeId = getCommentableTypeForDeviationType(typeId);
    const { tier , isSubscribedButBlocked , needsSubscription  } = useSubscriptionTier(deviation);
    const isBlocked = needsSubscription || isSubscribedButBlocked;
    const { showVideoAd , showAtfAd , showAdhesionAd  } = useShowMobileAd(deviation);
    const adSafety = useSelector((state)=>getCurrentAdSafety(state));
    const isNsfgFallback = useFlag('ads_dealer_nsfg');
    // we'll force a re-render of the page when a countdown in the offer banner of the monetization strip
    // reaches 0 (onAdoptableSaleEnd). This will update the actionbar to change from the 'make an offer'
    // button to the 'view offers' button to show the sale is over
    const [hasAdoptionEnded, setHasAdoptionEnded] = useState(false);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, showAdhesionAd && /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "MobileAdhesion"
    }, /*#__PURE__*/ React.createElement(AnonOrUserUnit, {
        anon: MobileAdhesion,
        user: UserMobileAdhesion,
        safety: adSafety
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, showAtfAd && (adSafety !== 'off' || isNsfgFallback) && /*#__PURE__*/ React.createElement("div", {
        className: s['ad-wrapper-static-atf']
    }, /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "MobileDevPageStage320x100"
    }, /*#__PURE__*/ React.createElement(MobileDevPageStage320x100, {
        safety: adSafety
    }))), /*#__PURE__*/ React.createElement(ArtStage, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(MonetizationStrip, {
        className: s['strip-tier-promotion'],
        deviation: deviation,
        onAdoptableSaleEnd: ()=>setHasAdoptionEnded(true)
    }), showVideoAd && (adSafety !== 'off' || isNsfgFallback) && /*#__PURE__*/ React.createElement("div", {
        className: s['ad-wrapper']
    }, /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "MobileDevPageVideoStage"
    }, /*#__PURE__*/ React.createElement(MobileDevPageVideoStage, {
        safety: adSafety
    }))), /*#__PURE__*/ React.createElement(ActionBar, {
        // maintain a key so we can force a re-render
        key: `actionbar-${hasAdoptionEnded}`,
        deviation: deviation
    }), isLiterature && /*#__PURE__*/ React.createElement("div", {
        className: s['lit-content']
    }, /*#__PURE__*/ React.createElement(LiteratureTextualContent, {
        deviation: deviation
    })), /*#__PURE__*/ React.createElement(PanelPopup, {
        deviation: deviation,
        actionBarType: "primary",
        className: s['large-popover-uplifted']
    }), /*#__PURE__*/ React.createElement(Details, {
        contentClassName: s['details'],
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(UserGiftSaleBanner, {
        user: deviation.author
    }), isJournalOrLit && isBlocked && /*#__PURE__*/ React.createElement(SubPaywall, {
        deviation: deviation,
        showImage: false
    }), isExtendedLoaded ? /*#__PURE__*/ React.createElement(React.Fragment, null, !isBlocked && /*#__PURE__*/ React.createElement(Comments, {
        key: `${commentableTypeId}:${deviationId}`,
        deviation: deviation,
        className: s['comments']
    }), !isBlocked && !!tier && /*#__PURE__*/ React.createElement(TierUpsell, {
        className: s['upsell'],
        deviation: deviation
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['sidebar']
    }, /*#__PURE__*/ React.createElement(Sidebar, {
        deviation: deviation
    }))) : /*#__PURE__*/ React.createElement(LoadingIndicator, {
        className: s['lloader'],
        view: "llama"
    }), isBlocked && !!tier && /*#__PURE__*/ React.createElement(TierUpsell, {
        className: s['upsell'],
        deviation: deviation
    })));
};
MobileDeviationPage.displayName = 'MobileDeviationPage';
export default MobileDeviationPage;
